<template>
    <div class="document-container">
        <h2>积分充值</h2>
        <p>登录后进入“账户中心”，点击“充值积分”。</p>

        <div class="imageInfo">
            <img src="@/assets/userBook/image21.png" />
        </div>

        <p>支持微信支付，充值成功后积分自动到账，可用于各功能模块的调用。</p>
        <p>另外提供VIP专属定制服务，可根据要求量身定制专属套餐。</p>

        <div class="imageInfo">
            <img src="@/assets/userBook/image20.png" />
        </div>

        <p>【购买会员】：春节回馈新老用户，新用户注册即送1000积分免费体验，另外上架四款会员套餐，用户可根据需求进行购买；还可为用户定制专属会员套餐。</p>

        <div class="imageInfo">
            <img src="@/assets/userBook/image19.png" />
        </div>


        <p>【子账号管理】：机构版会员可添加10个子账号。</p>

        <div class="imageInfo">
            <img src="@/assets/userBook/image18.png" />
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.document-container {
    max-width: 1000px;
    margin: 0 auto;
    // padding: 20px;
    font-family: "Microsoft YaHei", sans-serif;
    color: #000;
    line-height: 1.6;
}

.imageInfo {
    width: 800px;
    box-shadow: 0px 1px 20px #eeeeee;
    margin: 50px 0px;

    img {
        width: 100%;
    }
}
</style>